import { render } from "./TreeNode.vue?vue&type=template&id=bfa8d8e2&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"

import "./TreeNode.vue?vue&type=style&index=0&id=bfa8d8e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa8d8e2"]])

export default __exports__